<div class="modal inmodal fade in parcel-modal create-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title col-sm-8">Welcome Message</h4>
                </div>
                <div class="modal-body" *ngIf="!authService.userIsResident">
                    <div [ngClass]="{'welcome-header' : showEditPanel}" (dblclick)="showEditPanelSetter()">
                        <h3>
                            <i *ngIf="!showEditPanel" class="fa fa-pencil"
                               (click)="showEditPanelSetter()"
                               data-placement="top" data-toggle="tooltip" title="Edit"></i>
                        </h3>
                        <div *ngIf="!showEditPanel"
                             [innerHtml]="this.propertyService.currentWelcomeMessage | safeHtml"></div>
                        <div *ngIf="showEditPanel" class="dv-value-edit">
                            <button type="submit" [disabled]="disabledSubmit">
                                <i class="fa fa-check"></i>
                            </button>

                            <button type="button" (click)="closeEditPanel()">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div *ngIf="showEditPanel">
                        <div class="form-group" id="summernote">{{welcomeMessage | safeHtml}}</div>
                    </div>
                </div>
                <div class="modal-body" *ngIf="authService.userIsResident">
                    <div class="form-group" id="summernote"
                        [innerHtml]="residentService.selectedBuilding.welcomeMessage | safeHtml"></div>
                    <span>
                        <input type="checkbox"
                               [ngModelOptions]="{standalone: true}"
                               [ngStyle]="{'height': '12px'}"
                               [ngModel]="residentService.dontShowWelcomeMessage"
                               (change)="residentService.dontShowWelcomeMessage = !residentService.dontShowWelcomeMessage" />
                        Don't show this message again
                    </span>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/welcome-message-modal/welcome-message-modal.component.html